import React from "react";
import { connect } from "react-redux";

import PropTypes from "prop-types";
import HelpIcon from "@material-ui/icons/HelpOutline";
import { makeStyles } from "@material-ui/core/styles";
import { WILDCARD_ORG_ID } from "../../lib/api/API";

const useStyles = makeStyles((theme) => ({
  button: {
    left: 20,
    bottom: 15,
    height: 45,
    width: "auto",
    zIndex: 9999,
    color: "white",
    padding: "1rem",
    display: "flex",
    fontSize: "1rem",
    position: "fixed",
    fontWeight: "700",
    alignItems: "center",
    borderRadius: "999rem",
    backgroundColor: "#3E7EF8",
    justifyContent: "space-around",
    "&:hover": {
      color: "white",
      textDecoration: "none",
    },
  },
  icon: {
    marginRight: 5,
  },
}));

const Zendesk = (props) => {
  const { email, name, orgId, license, toplevel } = props;

  const classes = useStyles();
  let helpDeskUrl;
  let helpButtonText = "Help";

  if (toplevel === "mspportal") {
    helpDeskUrl = `https://blumirapartners.zendesk.com/hc/en-us?name=${name}&email=${email}`;
  } else if (orgId === WILDCARD_ORG_ID) {
    helpDeskUrl = `https://blumira.zendesk.com/hc/en-us?name=${name}&email=${email}`;
  } else if (
    license.licenseMap[orgId].license &&
    license.licenseMap[orgId].license === "FREE"
  ) {
    helpDeskUrl = "https://blumirasecurity.zendesk.com/";
  } else {
    helpDeskUrl = `https://blumira.zendesk.com/hc/en-us?name=${name}&email=${email}`;
  }

  return (
    <a
      className={classes.button}
      href={helpDeskUrl}
      target={"_blank"}
      rel={"noopener noreferrer"}
    >
      <HelpIcon className={classes.icon} />
      {helpButtonText}
    </a>
  );
};

Zendesk.propTypes = {
  name: PropTypes.string,
  email: PropTypes.string,
};

Zendesk.defaultProps = {
  name: "",
  email: "",
};

const mapStateToProps = (state) => {
  if (!state?.session?.settings?.user) return {};

  const { email, first_name, last_name } = state?.session?.settings?.user;
  const license = state.license;
  const orgId = state.location.payload.orgId;
  const toplevel = state.location.payload.toplevel;

  return {
    email,
    name: `${first_name} ${last_name}`,
    license: license,
    orgId: orgId,
    toplevel: toplevel,
  };
};

export default connect(mapStateToProps, null)(Zendesk);
